<template>
  <v-autocomplete
    :class="compClass"
    v-model="elValue"
    :items="items"
    :label="label"
    :item-text="itemtext"
    :item-value="itemvalue"
    :return-object="returnObject"
    :placeholder="placeholder"
    :disabled="disabled"
    :hide-details="hideDetails"
    :readonly="readonlyElement"
    :multiple="multiple"
    @change="change"
    @blur="onBlur"
    @focus="onFocus"
    v-validate="validateRules"
    :data-vv-name="validateName"
    :error-messages="errorMessages"
    :data-vv-validate-on="required ? 'input' : 'change'"
    :autofocus="autofocus"
    :menu-props="{ minWidth: minWidth }"
  >
    <template v-slot:append-outer>
      <el-tooltip v-if="tooltip" :tooltip="tooltip" autocomplete />
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          {{ noData }}
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'ElAutocomplete',
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: ' ' },
    items: Array,
    itemtext: String,
    itemvalue: String,
    returnObject: Boolean,
    hideDetails: [Boolean, String],
    required: Boolean,
    need: Boolean,
    tooltip: String,
    value: [String, Number, Object, Array, Boolean],
    disabled: Boolean,
    readonly: Boolean,
    multiple: Boolean,
    autoSelectFirst: Boolean,
    validateKey: String,
    autofocus: { type: Boolean, default: false },
    minWidth: [String, Number],
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    noData() {
      return 'Nėra duomenų'
    },
    validateName() {
      return this.validateKey ?? this.label
    },
    validateMessages() {
      return {
        'field is required': this.$t('Laukas privalomas'),
      }
    },
    validateRules() {
      let rule = ''
      rule = this.required ? 'required' : ''
      return rule
    },
    errorMessages() {
      const messages = this.errors.collect(this.label)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find(item =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonlyElement
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
    readonlyElement() {
      return this.readonly || this.items.length === 1
    },
  },
  created() {
    this.autoSelect()
  },
  methods: {
    change() {
      this.$emit('change')
    },
    onBlur(e) {
      this.$emit('blur', e.target.value)
    },
    onFocus(e) {
      this.$emit('focus', e.target.value)
    },
    autoSelect() {
      if (this.items.length === 1 || (this.autoSelectFirst && !this.elValue)) {
        let value = this.returnObject
          ? this.items[0]
          : this.items[0][this.itemvalue]
        this.elValue = this.multiple ? [value] : value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
